<div class="field">
    @if (label()) {
        <label [for]="inputId()">{{ label() }}</label>
    }
    <div class="control">
        <cl-select
            [inputId]="inputId()"
            [options]="options()"
            optionLabel="label"
            optionValue="value"
            [placeholder]="placeholder()"
            [filter]="filter()"
            [loading]="loading()"
            [emptyFilterMessage]="'common.no-results' | translate"
            [formControl]="control()"
        />
        <ng-content />
    </div>
    <app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
</div>
